import "core-js/modules/es.array.concat.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useStore } from "../../../utils";
import { useEffect } from "react";
import { observer } from "mobx-react-lite";

function DataLayer(props) {
  var _store$user, _store$user$analytics, _store$common, _store$common$appAttr, _store$common$appAttr2, _store$common$appAttr3;

  var store = useStore();
  var dataLayerJSON = (_store$user = store.user) === null || _store$user === void 0 ? void 0 : (_store$user$analytics = _store$user.analyticsModel) === null || _store$user$analytics === void 0 ? void 0 : _store$user$analytics.dataLayerJSON;
  var brandname = store === null || store === void 0 ? void 0 : (_store$common = store.common) === null || _store$common === void 0 ? void 0 : (_store$common$appAttr = _store$common.appAttributes) === null || _store$common$appAttr === void 0 ? void 0 : (_store$common$appAttr2 = _store$common$appAttr.concept) === null || _store$common$appAttr2 === void 0 ? void 0 : (_store$common$appAttr3 = _store$common$appAttr2.conceptCode) === null || _store$common$appAttr3 === void 0 ? void 0 : _store$common$appAttr3.toLowerCase();
  useEffect(function () {
    try {
      window.digitalData = dataLayerJSON;
    } catch (error) {
      window.digitalData = "{}";
    }
  }, [JSON.stringify(dataLayerJSON)]);
  useEffect(function () {
    // To set page Name and title if provided
    if (props !== null && props !== void 0 && props.analyticsData) {
      var _store$user2, _store$user2$analytic, _props$analyticsData, _props$analyticsData2;

      store === null || store === void 0 ? void 0 : (_store$user2 = store.user) === null || _store$user2 === void 0 ? void 0 : (_store$user2$analytic = _store$user2.analyticsModel) === null || _store$user2$analytic === void 0 ? void 0 : _store$user2$analytic.setPageAnalyticsDetails({
        pageName: "".concat(brandname, "|").concat(props.analyticsData.pageName),
        pageType: "".concat(brandname, "|").concat(props.analyticsData.pageType),
        productCategoryPageType: props === null || props === void 0 ? void 0 : (_props$analyticsData = props.analyticsData) === null || _props$analyticsData === void 0 ? void 0 : _props$analyticsData.productCategoryPageType,
        primaryCategory: props === null || props === void 0 ? void 0 : (_props$analyticsData2 = props.analyticsData) === null || _props$analyticsData2 === void 0 ? void 0 : _props$analyticsData2.primaryCategory
      });
    }
  }, [props === null || props === void 0 ? void 0 : props.analyticsData]);

  var handleVisibilityChange = function handleVisibilityChange() {
    // Whenever tab become active (Tab Switch, Window Minimize)
    if (!document.hidden) {
      var _store$common2;

      store === null || store === void 0 ? void 0 : (_store$common2 = store.common) === null || _store$common2 === void 0 ? void 0 : _store$common2.trackSession();
    }
  };

  useEffect(function () {
    var _store$common3;

    store === null || store === void 0 ? void 0 : (_store$common3 = store.common) === null || _store$common3 === void 0 ? void 0 : _store$common3.trackSession();
    document.addEventListener("visibilitychange", handleVisibilityChange); // Cleanup event listener

    return function () {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {});
}

export default observer(DataLayer);